import request from '@/utils/request'

const advances = {
  // 查询垫款充值列表
  listAdvancesRecharge(query) {
    return request({
      url: '/cont/advancesRecharge/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询记录数量
  getAdvancesRechargeCountItem(query) {
    return request({
      url: '/cont/advancesRecharge/getCountItem',
      method: 'get',
      params: query
    })
  },
  // 获取新收款记录明细详细信息
  getNewIncomeDetail(advancesRechargeId) {
    return request({
      url: '/cont/advancesRecharge/' + advancesRechargeId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 修改新收款记录明细
  updateNewIncomeDetail(data) {
    return request({
      url: '/cont/advancesRecharge',
      method: 'put',
      data: data
    })
  },

  // 查询详情  参数 列表的advancesRechargeId和dataType
  getItemById(data) {
    return request({
      url: '/cont/advancesRecharge/getItemById',
      method: 'post',
      data: data
    })
  },
  // 查询详情  参数 销售收款dataType=1，需求发送dataType=2  ，contAdvancesId=对应列表的认领记录的主键ID
  getInfoById(data) {
    return request({
      url: '/cont/advancesRecharge/getInfoById',
      method: 'post',
      data: data
    })
  },

  // 根据账户ID获取相关合同收款信息
  getRechargeFront(data) {
    return request({
      url: '/cont/execAccount/rechargeFront',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 垫款未回款金额的查询
  getRechargeAmount(query) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getRechargeAmount',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 巨量充值申请之后调
  getRechargeBind(data) {
    return request({
      url: '/cont/execAccount/rechargeBind',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 账户ID绑定合同项目后，根据合同ID、执行客户ID获取认领记录或垫款记录接口：
  getClaimRecord(data) {
    return request({
      url: '/cont/execAccount/getClaimRecord',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 判断是否显示显示在线充值按钮
  getAccountMediaRechargeType(data) {
    return request({
      url: '/cont/execAccount/getAccountMediaRechargeType',
      method: 'post',
      data: data
    })
  },
  // 充值保存
  addRecharge(data) {
    return request({
      url: '/cont/execAccount/recharge',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 退款时获取保证金和可转余额接口
  getAccountBalance(data) {
    return request({
      url: '/cont/execAccount/getAccountBalance',
      method: 'post',
      data: data
    })
  },
  // 调拨之前调用
  refundFront(data) {
    return request({
      url: '/cont/execAccount/refundFront',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 退款保存
  addRefund(data) {
    return request({
      url: '/cont/execAccount/refund',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  }
}

export default advances
